import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AutofocusDirective } from '../autofocus/autofocus.directive';
import { IconComponent } from '../icon/icon.component';

export type SearchInputSize = 'mini' | 'regular';

@Component({
  standalone: true,
  selector: 'capra-search-input, mode-capra-search-input', // We need and additonal mode-* prefix selector here to support page that has both AngularJS and Angular dependency.
  imports: [AutofocusDirective, CommonModule, FormsModule, IconComponent],
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchInputComponent implements OnChanges {
  @Input() size: SearchInputSize = 'mini';
  @Input() disabled = false;
  @Input() autofocus = false;
  @Input() error = false;
  @Input() placeholder = '';
  @Input() text = '';
  @Output() textChange = new EventEmitter<string>();

  @ViewChild('input')
  inputField: ElementRef | undefined;

  @HostBinding('class')
  sizeClass = this._createHostClass(this.size);

  icon: 'icon-close' | 'icon-search' = 'icon-search';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text']) {
      this.icon = changes['text'].currentValue ? 'icon-close' : 'icon-search';
    }

    if (changes['size']) {
      this.sizeClass = this._createHostClass(this.size);
    }
  }

  onIconClick(): void {
    if (this.disabled || this.icon !== 'icon-close') {
      return;
    }
    this.textChange.emit('');
    this.inputField?.nativeElement.focus();
  }

  private _createHostClass(size: SearchInputSize): string {
    return `capra-search-input-${size}`;
  }
}
